import React from "react";
import { ChatBubbleLeftRightIcon, SparklesIcon } from "@heroicons/react/24/solid";

/**
 * Contextual "Ask the Council" button. Click → dispatches a window event
 * the floating ChatWidget listens for, opens the panel, and auto-sends the
 * prefilled question. Use for any data point that has a "why?" attached.
 *
 * Variants:
 *   - inline (default): text + arrow, fits under cards / next to titles
 *   - icon: tight icon-only button, fits inside table rows
 */
const AskCouncilButton = ({
  prefill,
  variant = "inline",
  label = "Ask the Council",
  className = "",
  onAsk,
}) => {
  if (!prefill) return null;
  const fire = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    if (onAsk) {
      onAsk(prefill);
      return;
    }
    window.dispatchEvent(
      new CustomEvent("council:askPrefill", { detail: { prefill } }),
    );
  };

  if (variant === "icon") {
    return (
      <button
        type="button"
        onClick={fire}
        title={`Ask the Council: "${prefill.slice(0, 80)}${prefill.length > 80 ? "…" : ""}"`}
        aria-label="Ask the Council"
        className={`inline-flex items-center justify-center w-7 h-7 rounded-lg text-indigo-500 hover:text-indigo-400 hover:bg-indigo-500/10 transition ${className}`}
      >
        <ChatBubbleLeftRightIcon className="w-4 h-4" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={fire}
      className={`inline-flex items-center gap-1.5 text-xs font-semibold text-indigo-500 hover:text-indigo-400 hover:underline ${className}`}
    >
      <ChatBubbleLeftRightIcon className="w-3.5 h-3.5" />
      {label}
      <SparklesIcon className="w-3 h-3" />
    </button>
  );
};

export default AskCouncilButton;
